export const TYPE_BENEFIT = [
    {
        label: 'Gift',
        value: 'free-gift',
    },
    {
        label: 'Potongan Belanja',
        value: 'shopping-discount',
    },
    {
        label: 'Potongan Ongkir',
        value: 'shipping-discount',
    },
]

export const INIT_STATE = {
    name: null,
    type: TYPE_BENEFIT[0],
    gift: {
        benefit_id: null,
        quantity: 1,
    },
    discount_amount: null,
    point_needed: null,
    start_date: null,
    end_date: null,
}

export const GET_FIELD_NAME = {
    name: 'Nama benefit',
    type: 'Tipe',
    point_needed: 'Nilai penukaran point',
    start_date: 'Tanggal mulai',
    end_date: 'Tanggal berakhir',
}

export const FIELD_NAME_DISCOUNT = {
    ...GET_FIELD_NAME,
    discount_amount: 'Nilai Potongan',
}

export const FIELD_NAME_GIFT = {
    benefit_id: 'Gift',
    quantity: 'Kuantitas',
}
